import { useCallback, useEffect, useState } from 'react';

import { getSubscriptionsPlans } from '../components/trashie/utils/service';
import { getSubscriptionPlanValues, getSubscriptionPlanInterval } from '../components/trashie/utils/subscriptions';

const useSubscriptionPlans = ({ enabled = true } = {}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [planValue, setPlanValue] = useState(null);
  const [planPrevValue, setPlanPrevValue] = useState(null);
  const [planInterval, setPlanInterval] = useState(null);

  const loadSubscriptionPlans = useCallback(async () => {
    setIsLoading(true);

    const { data, error } = await getSubscriptionsPlans();

    if (error) {
      setPlanValue(null);
      setPlanPrevValue(null);
      setPlanInterval(null);
      setIsLoading(false);
      return;
    }

    const { value, prevValue } = getSubscriptionPlanValues(data);

    setPlanValue(value);
    setPlanPrevValue(prevValue);
    setPlanInterval(getSubscriptionPlanInterval(data?.interval));

    setIsLoading(false);
  }, []);

  useEffect(() => {
    if (enabled) {
      loadSubscriptionPlans();
    }
  }, [enabled, loadSubscriptionPlans]);

  return {
    isLoading: enabled ? isLoading : false,
    planValue,
    planPrevValue,
    planInterval,
  };
};

export default useSubscriptionPlans;
